import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useThemeStore } from "@/shared/theme";

export function ThemeToggle() {
	const mode = useThemeStore((state) => state.mode);
	const toggle = useThemeStore((state) => state.toggle);
	const nextLabel = mode === "dark" ? "Yorug' rejim" : "Tungi rejim";

	return (
		<Tooltip title={nextLabel}>
			<Button
				type="text"
				aria-label={nextLabel}
				onClick={toggle}
				icon={mode === "dark" ? <SunOutlined /> : <MoonOutlined />}
			/>
		</Tooltip>
	);
}
